module.exports = __webpack_public_path__ + "/images/logo-fr-kiabi.30dfcb6.png";